/**
 * Do not edit directly
 * Generated on Fri, 25 Nov 2022 14:07:59 GMT
 */
export var space1 = "4px";
export var space2 = "8px";
export var space3 = "12px";
export var space4 = "16px";
export var space5 = "20px";
export var space6 = "24px";
export var space7 = "28px";
export var space8 = "32px";
export var space9 = "36px";
export var space10 = "40px";
export var space11 = "44px";
export var space12 = "48px";
export var space13 = "52px";
export var space14 = "56px";
export var space15 = "60px";
export var space16 = "64px";
export var space17 = "68px";
export var space18 = "72px";
export var space19 = "76px";
export var space20 = "80px";
export var space24 = "96px";
export var spaceBase = "4px";
//# sourceMappingURL=spacing.js.map